import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  API_PATH_AFWHITELIST,
  AfWhitelist,
} from './afWhitelist.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getAfWhitelistList(
): AxiosPromise<ServerResponse<AfWhitelist>> {
  return http.get(`${API_PATH_AFWHITELIST}`);
}

export function getAfWhitelist(
  id: string,
): AxiosPromise<ServerResponse<AfWhitelist>> {
  return http.get(`${API_PATH_AFWHITELIST}/${id}`);
}

export function createAfWhitelist(
  body: WithAuditDetails<AfWhitelist>,
): AxiosPromise<ServerResponse<AfWhitelist>> {
  return http.post(`${API_PATH_AFWHITELIST}`, body);
}

export function updateAfWhitelist(
  id: string,
  body: WithAuditDetails<AfWhitelist>,
): AxiosPromise<ServerResponse<AfWhitelist>> {
  return http.put(`${API_PATH_AFWHITELIST}/${id}`, body);
}

export function deleteAfWhitelist(
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<AfWhitelist>> {
  return http.delete(`${API_PATH_AFWHITELIST}/${id}`, { data: body.auditDetails });
}
